// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"0c896918","796":"78e91036"}[chunkId] + ".chunk.js";
};